import { render, staticRenderFns } from "./Offer2.vue?vue&type=template&id=6c1675de&"
import script from "./Offer2.vue?vue&type=script&lang=js&"
export * from "./Offer2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports